/**
 * Ajuda dos campos do pos-emissao: a fila de endossos e a configuracao do endosso
 * (P-END-1).
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/endossos': {
    'Tipo de endosso':
      'Tipo do catalogo de endosso da empresa: neutro, alteracao, cancelamento ou aniversario. A solicitacao simplificada tem o tipo pelo kind de antes.',
    'Fluxo do endosso':
      'Operacao: o envio abre a operacao do tipo endosso, que passa pela esteira, e a emissao dela aplica o endosso. Solicitacao: a decisao e nesta fila.',
    Segregacao:
      'Registrar: quem pediu pode decidir, e a decisao fica marcada. Recusar: o servidor recusa a decisao e a emissao de quem abriu ou enviou o endosso.',
    'Novo subtipo':
      'Subtipo do tipo de endosso, informado na solicitacao. Nenhuma lista vem carregada: as listas de referencia conflitam (END-001).',
    'Novo motivo':
      'Motivo do endosso, escolhido no passo Motivo e documentos. O nome nao repete no subtipo.',
    'Documento exigido':
      'Documento que o motivo pede. O obrigatorio precisa ser enviado ou dispensado antes de gerar a cotacao.',
  },
};
